import { useState } from "react";
import SurveyIngestion from "@solimat/solimat-web-endpoint/lib/survey-ingestion";
import { RellenarEncuestaRequest } from "@solimat/solimat-web-endpoint/lib/survey-ingestion/dto";

const useRellenarEncuesta = () => {
  const BASE_URL = import.meta.env.VITE_REACT_APP_ENCUESTAS_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_ENCUESTAS_KEY || "";
  const apiSurvey = new SurveyIngestion.SurveyIngestionService(BASE_URL, FUNCTIONS_KEY);

  const [loadingRellenarEncuesta, setLoadingRellenarEncuesta] = useState(false);
  const [successRellenarEncuesta, setSuccessRellenarEncuesta] = useState(false);
  const [errorRellenarEncuesta, setErrorRellenarEncuesta] = useState(null);
  const [asignacionEncuestaId, setAsignacionEncuestaId] = useState<string>(null);

  const rellenarEncuesta = async (data: RellenarEncuestaRequest) => {
    setLoadingRellenarEncuesta(true);
    setErrorRellenarEncuesta(null);
    try {
      const res = await apiSurvey.rellenarEncuesta(data);
      setSuccessRellenarEncuesta(true);
      setLoadingRellenarEncuesta(false);
      setAsignacionEncuestaId(res.data as string)
      return res.data as string;
    }
    catch(err) {
      console.error("rellenarEncuesta error: ", err);
      setErrorRellenarEncuesta(err);
      setLoadingRellenarEncuesta(false);
    }
  };

  return {
    asignacionEncuestaId,
    rellenarEncuesta,
    successRellenarEncuesta,
    loadingRellenarEncuesta,
    errorRellenarEncuesta
  };
};

export default useRellenarEncuesta;